"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var check_1 = require("../check");
var text_1 = require("../text");
var controlled_1 = require("../form/controlled");
var call_both_1 = require("../_util/call-both");
var tooltip_1 = require("../tooltip");
var config_context_1 = require("../_util/config-context");
var noop_1 = require("../_util/noop");
exports.Switch = react_1.default.forwardRef(function Switch(props, ref) {
    var classPrefix = config_context_1.useConfig().classPrefix;
    // 支持从 Context 注入
    var context = react_1.useContext(check_1.CheckContext);
    if (context) {
        var checkProps = context.inject(tslib_1.__assign({ type: "checkbox" }, props));
        delete checkProps.type;
        // eslint-disable-next-line no-param-reassign
        props = checkProps;
    }
    var _a = controlled_1.useDefaultValue(props, false), name = _a.name, value = _a.value, disabled = _a.disabled, _b = _a.onChange, onChange = _b === void 0 ? noop_1.noop : _b, _c = _a.onClick, onClick = _c === void 0 ? noop_1.noop : _c, loading = _a.loading, tooltip = _a.tooltip, children = _a.children, className = _a.className, extraProps = tslib_1.__rest(_a, ["name", "value", "disabled", "onChange", "onClick", "loading", "tooltip", "children", "className"]);
    var component = (react_1.default.createElement("label", tslib_1.__assign({ ref: children ? undefined : ref, className: classnames_1.default(classPrefix + "-switch", { "is-loading": loading }, className) }, (children ? {} : extraProps)),
        react_1.default.createElement("input", { readOnly: true, type: "checkbox", className: classPrefix + "-switch__input", checked: value, disabled: disabled || loading, onClick: call_both_1.callBoth(children ? noop_1.noop : onClick, function (event) {
                var checked = event.currentTarget.checked;
                onChange(checked, {
                    event: event,
                    check: tslib_1.__assign(tslib_1.__assign({ type: "checkbox" }, props), { value: checked }),
                });
            }) }),
        react_1.default.createElement("span", { className: classPrefix + "-switch__toggle" })));
    // 默认是不需要 children 的，如果提供了，需要包装一层
    if (children) {
        component = (react_1.default.createElement("label", tslib_1.__assign({ ref: ref, onClick: function (event) {
                var _a;
                // 多次触发
                if (((_a = event.target) === null || _a === void 0 ? void 0 : _a.tagName) !== "SPAN") {
                    onClick(event);
                }
            }, style: { cursor: disabled ? "default" : "pointer" } }, extraProps),
            component,
            react_1.default.createElement(text_1.Text, { reset: true, style: { verticalAlign: "middle", margin: "0 5px" } }, children)));
    }
    if (tooltip) {
        component = react_1.default.createElement(tooltip_1.Tooltip, { title: tooltip }, component);
    }
    return component;
});
exports.Switch.displayName = "Switch";
//# sourceMappingURL=Switch.js.map